import "./Spinner.css";

const Spinner = () => {
  return (
    <>
      <div className="loadingio-spinner-dual-ball-dmk7kqcu4gc">
        <div className="ldio-ebee9r0zvfc">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </>
  );
};
export default Spinner;
